"use client"

import { GuidesDialog } from '@/components/guides/GuidesDialog';
import PaperList from '@/components/papers/PaperList';
import { useGuides, usePayment, useUser, useUserVip } from '@/stores/appStore';


export default function PaperListPage() {
  const { markGuidesViewed } = useGuides();
  const {
    setPaymentSuccessOpenWithTitle,
  } = usePayment();
  const {
    receivePaymentVip,
  } = useUser();
  const {
    isLargePaymentUser,
  } = useUserVip();
  return (
    <>
      <PaperList />
      <GuidesDialog scene="PaperList" />
      {
        isLargePaymentUser ? (
          <GuidesDialog scene="VIP"
            onDone={(type) => {
              if (type === 'receive_vip_alert') {
                (async () => {
                  await receivePaymentVip();
                  setPaymentSuccessOpenWithTitle('Plus 会员领取成功');
                })()
              }
            }}
            onClose={(type) => {
              if (type === 'receive_vip_alert') {
                markGuidesViewed('VIP');
              }
            }}
          />
        ) : null
      }
    </>
  );
}

